import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';

function acceptJobRequest(id: string) {
  return getSMPBackendAPIAdmin().resourceBookingsControllerAcceptRequestedServiceBookingV1(id);
}

export function useAcceptJobRequest() {
  return useMutation({ mutationFn: acceptJobRequest });
}
